import { render } from "./VoucherBundleDetail.vue?vue&type=template&id=8f5ad90c&scoped=true"
import script from "./VoucherBundleDetail.vue?vue&type=script&lang=js"
export * from "./VoucherBundleDetail.vue?vue&type=script&lang=js"

import "./VoucherBundleDetail.vue?vue&type=style&index=0&id=8f5ad90c&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f5ad90c"]])

export default __exports__